import React, { useMemo, useCallback, useEffect } from 'react';
import { Formik } from 'formik';
import { bindActionCreators } from 'redux';
import { connect, useSelector } from 'react-redux';
import classNames from 'classnames';

import { CreateUser, Button, useDisableUserModal, useSwitchAdminModal } from '../../../components';
import { updateUser, getUserDetails } from '../../../store/users';
import { BackIcon } from '../../../assets';
import { createUserSchema, updateUserSchema } from '../../../utils/validations';
import { LodashHelper, renderRecordValue } from '../../../utils/';
import { USER_ROLES, USER_STATUSES } from '../../../constants/constants';

import styles from './index.module.css';
import { fetchAllHealthOrganizations } from '../../../store/health_organizations';

const UpdateUser = ({
  userDetails,
  getUserDetails,
  Navigation,
  updateUser,
  title,
  managedRole,
  headText,
  id,
  changeRole,
  handleConfirmDisableUser,
  healthOrganizations,
  isViewDashboardMode,
  fetchAllHealthOrganizations,
  disableEmail = false,
}) => {
  const user = useSelector((state) => state.authorization.user);
  const navigate = Navigation;
  const showSetAsAdminBtn = useMemo(
    () =>
      userDetails.role &&
      ![USER_ROLES.TC_ADMIN, USER_ROLES.HO_ADMIN, USER_ROLES.SUPER_ADMIN].includes(userDetails?.role),
    [userDetails],
  );

  const showDeactivateButton = useMemo(() => {
    return (
      (userDetails.role && userDetails.role === USER_ROLES.SUPER_ADMIN) ||
      userDetails.role === USER_ROLES.TC_ADMIN ||
      userDetails.role === USER_ROLES.HO_ADMIN
    );
  }, [userDetails.role]);

  const userIsActive = useMemo(
    () =>
      userDetails?.status &&
      userDetails?.status !== USER_STATUSES.INVITED &&
      userDetails?.status &&
      userDetails?.status !== USER_STATUSES.DISABLED,
    [userDetails],
  );

  const { DisableUserModal, setDisableUserModalVisible } = useDisableUserModal({
    handleConfirm: handleConfirmDisableUser,
    userName:
      userDetails?.firstName &&
      userDetails?.lastName &&
      renderRecordValue(`${userDetails?.firstName} ${userDetails?.lastName}`),
  });

  // const { SwitchAdminModal, setSwitchAdminModalVisible } = useSwitchAdminModal({
  //   handleConfirm: changeRole,
  //   userName:
  //     userDetails?.firstName &&
  //     userDetails?.lastName &&
  //     renderRecordValue(`${userDetails?.firstName} ${userDetails?.lastName}`),
  // });

  const handleToggleDisableModal = useCallback(
    (flag) => () => setDisableUserModalVisible(flag),
    [setDisableUserModalVisible],
  );

  // const handleToggleSwitchAdminModal = useCallback(
  //   (flag) => () => setSwitchAdminModalVisible(flag),
  //   [setSwitchAdminModalVisible],
  // );
  useEffect(() => {
    getUserDetails(id);
    if (user.parentOrgId && userDetails?.role === USER_ROLES.HO_EMPLOYEE) {
      fetchAllHealthOrganizations();
    }

    return;
  }, [id, getUserDetails, isViewDashboardMode, fetchAllHealthOrganizations]);

  const handleBack = () => {
    navigate.back();
  };
console.log('UpdateUser userDetails', userDetails, managedRole);
  return (
    <div className={styles.pageContent}>
      <div className={styles.header}>
        <div className={styles.backBtn} onClick={handleBack}>
          <BackIcon width='26px' height='26px' fill='#E1F4D3' />
        </div>
        <h1 className={styles.pageTitle}>{title}</h1>
      </div>
      <div>
        <h2>{headText}</h2>
        <Formik
          enableReinitialize
          validationSchema={userIsActive ? updateUserSchema : createUserSchema}
          validateOnMount
          initialValues={userDetails}
          onSubmit={(values) => updateUser({ id, values, Navigation: navigate })}>
          {({ values, ...rest }) => {
            return (
              <form className={styles.form} onSubmit={rest.handleSubmit}>
                <CreateUser
                  values={values}
                  {...rest}
                  showPersonalInfo={userIsActive}
                  disableEmail={disableEmail}
                  healthOrganizations={healthOrganizations}
                  isParentOrg={!!user.parentOrgId}
                  managedRole={managedRole}
                />

                <div className={styles.btnPanel}>
                  {userIsActive && (showDeactivateButton || showSetAsAdminBtn) && (
                    <div className={styles.manageUserBtns}>
                      <div className={styles.btnControl}>
                        <Button myClassName={styles.navigationBtn} onClick={handleToggleDisableModal(true)}>
                          Deactivate {managedRole}
                        </Button>
                      </div>
                      {showSetAsAdminBtn && changeRole && (
                        <div className={styles.btnControl}>
                          <Button myClassName={styles.navigationBtn} onClick={() => changeRole(true)}>
                            Set as Admin
                          </Button>
                        </div>
                      )}
                      {!showSetAsAdminBtn && changeRole && (
                        <div className={styles.btnControl}>
                          <Button myClassName={styles.navigationBtn} onClick={() => changeRole(false)}>
                            Set as User
                          </Button>
                        </div>
                      )}
                    </div>
                  )}
                  <div
                    className={classNames({
                      [styles.btnControl]: true,
                      [styles.saveBtn]: true,
                    })}>
                    <Button disabled={!rest.isValid || LodashHelper.isEqual(values, userDetails)} type='submit'>
                      Save Changes
                    </Button>
                  </div>
                </div>
              </form>
            );
          }}
        </Formik>
      </div>

      {DisableUserModal}
      {/* {showSetAsAdminBtn && SwitchAdminModal} */}
    </div>
  );
};

const mapStateToProps = (state) => ({
  healthOrganizations: state.healthOrganizations.healthOrganizations,
  userDetails: {
    email: state?.users?.userDetails?.email,
    firstName: state?.users?.userDetails?.firstName,
    lastName: state?.users?.userDetails?.lastName,
    jobTitle: state?.users?.userDetails?.jobTitle,
    phoneNumber: state?.users?.userDetails?.phoneNumber,
    role: state?.users?.userDetails?.role,
    status: state?.users?.userDetails?.status,
    emailSubscription: state?.users?.userDetails?.emailSubscription === null
      ? true : state?.users?.userDetails?.emailSubscription,
    orgList: state?.users?.userDetails?.permissions?.orgList,
  },
  isViewDashboardMode: state?.authorization?.viewDashboardMode?.active,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  fetchAllHealthOrganizations,
  updateUser,
  getUserDetails
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(UpdateUser);
